import { getCentralCostList, getStructuresList, } from '@/api/requests/structures';
import { ref, watch } from '@vue/composition-api';
import { DEFAULT_STATS } from '@/views/Brand/Places/_components/budget-summary/_constants';
export const useBudgetSummary = (ctx, updatesCounter) => {
    const isLoading = ref(false);
    const summaryStats = ref(DEFAULT_STATS);
    const centralCosts = ref([]);
    const centralCostsStats = ref([]);
    const lastPage = ref(1);
    const page = ref(1);
    const perPage = ref(10);
    const params = ctx.root.$route.params;
    const brandId = params.id;
    let fetchToken = 0;
    const fetchSummaryStats = async () => {
        try {
            isLoading.value = true;
            const { nodes } = await getStructuresList({
                brandId,
                withBudget: true,
            });
            const root = nodes[0];
            summaryStats.value = {
                monthlyBudget: root?.totalBudget || 0,
                monthlyExpenses: root?.monthlyExpenses || 0,
                budgetUtilization: root?.budgetUtilization || 0,
                annualExpenses: root?.annualExpenses || 0,
            };
        }
        finally {
            isLoading.value = false;
        }
    };
    const fetchCentralCosts = async () => {
        try {
            isLoading.value = true;
            const { totalCount, nodes } = await getCentralCostList({
                brandId,
                page: page.value,
                perPage: perPage.value,
            });
            centralCosts.value = nodes;
            lastPage.value = Math.ceil(totalCount / perPage.value);
        }
        finally {
            isLoading.value = false;
        }
    };
    const fetchCentralCostsStats = async (tokenAtStart) => {
        try {
            isLoading.value = true;
            const results = [];
            await Promise.all(centralCosts.value.map(async (centralCost) => {
                const { nodes } = await getStructuresList({
                    brandId,
                    centralCostId: centralCost.id,
                    withBudget: true,
                });
                const root = nodes[0];
                results.push({
                    id: centralCost.id,
                    name: centralCost.name,
                    monthlyBudget: root?.totalBudget || 0,
                    monthlyExpenses: root?.monthlyExpenses || 0,
                    budgetUtilization: root?.budgetUtilization || 0,
                    annualExpenses: root?.annualExpenses || 0,
                    centralCost,
                });
            }));
            if (tokenAtStart !== fetchToken)
                return;
            centralCostsStats.value = results.sort((a, b) => b.monthlyExpenses - a.monthlyExpenses);
        }
        finally {
            isLoading.value = false;
        }
    };
    const fetchCentralCostsWithStats = async () => {
        const token = ++fetchToken;
        centralCostsStats.value = [];
        await fetchCentralCosts();
        if (token !== fetchToken)
            return;
        await fetchCentralCostsStats(token);
    };
    watch([updatesCounter, page, perPage], async () => {
        await Promise.all([fetchSummaryStats(), fetchCentralCostsWithStats()]);
    }, { immediate: true });
    watch(isLoading, () => ctx.emit('is-loading', isLoading));
    return {
        centralCostsStats,
        summaryStats,
        isLoading,
        lastPage,
        page,
        perPage,
    };
};
